import type { ComponentType } from 'react';
import {
  FiBox,
  FiFileText,
  FiLink2,
  FiPlus,
  FiSettings
} from 'react-icons/fi';

import type { RunNavItem, RunPageScreen } from './helpers/runScreenTypes';

type RunScreenIconComponent = ComponentType<{ 'aria-hidden'?: boolean }>;

const IconBox = FiBox as unknown as RunScreenIconComponent;
const IconFileText = FiFileText as unknown as RunScreenIconComponent;
const IconLink = FiLink2 as unknown as RunScreenIconComponent;
const IconPlus = FiPlus as unknown as RunScreenIconComponent;
const IconSettings = FiSettings as unknown as RunScreenIconComponent;

const RUN_NAV_ITEMS: RunNavItem[] = [
  { id: 'new-workspace', label: 'New', icon: 'new-workspace' },
  { id: 'findings', label: 'Findings', icon: 'findings' },
  { id: 'scope', label: 'Scope', icon: 'scope' },
  { id: 'tools', label: 'Tools', icon: 'tools' },
  { id: 'settings', label: 'Settings', icon: 'settings' }
];

const RUN_GITHUB_PROTECTED_SCREENS = new Set<RunPageScreen>(['new-workspace', 'scope', 'pricing']);

function RunNavIcon({ icon }: { icon: RunNavItem['icon'] }) {
  if (icon === 'new-workspace') {
    return <IconPlus aria-hidden={true} />;
  }

  if (icon === 'scope') {
    return <IconLink aria-hidden={true} />;
  }

  if (icon === 'settings') {
    return <IconSettings aria-hidden={true} />;
  }

  if (icon === 'tools') {
    return <IconBox aria-hidden={true} />;
  }

  return <IconFileText aria-hidden={true} />;
}

export { RUN_GITHUB_PROTECTED_SCREENS, RUN_NAV_ITEMS, RunNavIcon };
